/* My Space page: renders saved designs from product handles kept in localStorage. */
(() => {
  const list = document.querySelector('[data-my-list]');
  if (!list || !window.liroMySpace) return;
  const empty = document.querySelector('[data-my-empty]');
  const cta = document.querySelector('[data-my-cta]');
  const HANDLE = /^[a-z0-9-]{1,80}$/;

  const card = (p) => {
    const li = document.createElement('li');
    li.className = 'ldes__card lgrid__item';
    li.dataset.handle = p.handle;

    const media = document.createElement('a');
    media.className = 'ldes__media';
    media.href = p.url.split('?')[0];
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    const src = p.featured_image;
    if (src) {
      const img = document.createElement('img');
      img.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_640x$1$2');
      img.alt = '';
      img.loading = 'lazy';
      img.width = 640; img.height = 800;
      media.append(img);
    }

    const meta = document.createElement('div');
    meta.className = 'ldes__meta';
    const text = document.createElement('div');
    const h = document.createElement('h3');
    h.className = 'ldes__name';
    const a = document.createElement('a');
    a.href = media.href;
    a.textContent = p.title;
    h.append(a);
    const t = document.createElement('p');
    t.className = 'ldes__type';
    t.textContent = p.type || '';
    text.append(h, t);

    const rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'liro-btn liro-btn--ghost';
    rm.style.minHeight = '40px';
    rm.textContent = 'Remove';
    rm.setAttribute('aria-label', `Remove ${p.title} from My Space`);
    rm.addEventListener('click', () => {
      window.liroMySpace.toggle(p.handle);
      li.remove();
      const live = document.getElementById('liro-live');
      if (live) live.textContent = `${p.title} removed from My Space`;
      show();
    });
    meta.append(text, rm);
    li.append(media, meta);
    return li;
  };

  const show = () => {
    const n = list.children.length;
    empty.hidden = n > 0;
    cta.hidden = n === 0;
  };

  const handles = window.liroMySpace.all().filter((h) => HANDLE.test(h));
  if (!handles.length) { show(); return; }
  Promise.all(handles.map((h) => fetch(`/products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))
    .then((items) => {
      items.forEach((p, i) => {
        if (p) list.append(card(p));
        else window.liroMySpace.toggle(handles[i]); // product no longer exists: drop it
      });
      show();
    });
})();
